import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

import { getCookie } from '@/utils/utils'

const router = new Router({
  mode:"history",
  routes: [
    {
      path: '/auth-signin',
      name: 'signin',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/Signin/Index')
    },
    {
      path: '/bindPhone',
      name: 'bindPhone',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/bindPhone')
    },
    {
      path: '/select_identity',
      name: 'selectIdentity',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/selectIdentity/Index')
    },
    {
      path: '/signin_email',
      name: 'signinEmail',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/signinEmail/Index')
    },
    {
      path: '/signin_email_detail',
      name: 'signinEmailDetail',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/signinEmailDetail/Index')
    },
    {
      path: '/bind_phone',
      name: 'bindPhone',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/bindPhone/Index')
    },
    {
      path: '/link_sign_callbacks',
      name: 'linkSignCallbacks',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/linkSignCallbacks/Index')
    },
    {
      path: '/app_scan_code_login',
      name: 'appScanCodeLogin',
      meta: {
        title: '超级简历WonderCV',
      },
      component: () => import('./views/appScanCodeLogin/Index')
    }
  ]
})

// 路由守卫
router.beforeEach( (to, from, next) => {
  next()
})

export default router;
